"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInForm = exports.ERROR_USER_DEACTIVATED = exports.ERROR_UNEXPECTED = exports.ERROR_INVALID_CREDENTIALS = void 0;
const Button_1 = __importDefault(require("@targetx/mineral-ui/Button"));
const Form_1 = require("@targetx/mineral-ui/Form");
const Link_1 = __importDefault(require("@targetx/mineral-ui/Link"));
const Text_1 = __importDefault(require("@targetx/mineral-ui/Text"));
const TextInput_1 = __importDefault(require("@targetx/mineral-ui/TextInput"));
const palette_1 = __importDefault(require("@targetx/mineral-ui/themes/generated/palette"));
const Alert_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Alert"));
const Asterisk_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Asterisk"));
const Form_2 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Form"));
const Layout_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Layout"));
const lodash_get_1 = __importDefault(require("lodash.get"));
const react_1 = __importStar(require("react"));
const isEmail_1 = __importDefault(require("validator/lib/isEmail"));
const isEmpty_1 = __importDefault(require("validator/lib/isEmpty"));
const theme_1 = __importDefault(require("../../theme"));
const OrgBannerComponent_1 = __importDefault(require("./OrgBannerComponent"));
const SignInForm_copyText_1 = __importDefault(require("./SignInForm.copyText"));
exports.ERROR_INVALID_CREDENTIALS = 'ERROR_INVALID_CREDENTIALS';
exports.ERROR_UNEXPECTED = 'ERROR_UNEXPECTED';
exports.ERROR_USER_DEACTIVATED = 'ERROR_USER_DEACTIVATED';
function SignInForm({ action, csrfToken, errorMessageKey: _errorMessageKey, org, resetPasswordPath }) {
    const initialState = {
        errorMessageKey: _errorMessageKey,
        passwordInput: { value: '', isValid: false },
        usernameInput: { value: '', isValid: false }
    };
    const [state, setState] = (0, react_1.useState)(initialState);
    function changeState(partialState) {
        setState(currentState => ({ ...currentState, ...partialState }));
    }
    const { errorMessageKey, passwordInput, usernameInput } = state;
    const canSubmit = Object.entries(state).every(([key, input]) => key.endsWith('Input') ? input.isValid : true);
    const handleChange = (event) => {
        const { name, value } = event.target;
        let isValid = false;
        switch (name) {
            case 'password':
                isValid =
                    !(0, isEmpty_1.default)(value, { ignore_whitespace: true }) && value.length >= 8;
                break;
            case 'username':
                isValid = (0, isEmail_1.default)(value);
                break;
            default:
                break;
        }
        changeState({
            [`${name}Input`]: { value, isValid },
            errorMessageKey: undefined
        });
    };
    return (react_1.default.createElement(Layout_1.default, { as: Form_2.default, action: action, method: "post" },
        react_1.default.createElement(Layout_1.default.Header, null,
            react_1.default.createElement(Text_1.default, { as: "h1", fontSize: "1.5rem", fontWeight: "semiBold", marginTop: theme_1.default.space_stack_lg }, SignInForm_copyText_1.default.title)),
        react_1.default.createElement(Layout_1.default.Body, { marginTop: theme_1.default.space_stack_lg, paddingHorizontal: theme_1.default.space_inline_xxs, scrollable: true },
            renderErrorMessage({ errorMessageKey }),
            react_1.default.createElement(OrgBannerComponent_1.default, { org: org }),
            react_1.default.createElement(Form_1.FormField, { name: "username", input: TextInput_1.default, label: react_1.default.createElement(Text_1.default, { color: errorMessageKey === exports.ERROR_INVALID_CREDENTIALS ||
                        !isValidInput(usernameInput)
                        ? theme_1.default.color_danger
                        : '' },
                    SignInForm_copyText_1.default.usernameInputLabel,
                    react_1.default.createElement(Asterisk_1.default, { color: palette_1.default.red[60] })), marginBottom: theme_1.default.space_stack_md, required: true, tabIndex: 1, type: "text", value: usernameInput.value, variant: errorMessageKey === exports.ERROR_INVALID_CREDENTIALS ||
                    !isValidInput(usernameInput)
                    ? 'danger'
                    : undefined, onChange: handleChange }),
            react_1.default.createElement(Form_1.FormField, { name: "password", input: TextInput_1.default, label: react_1.default.createElement(Text_1.default, { color: errorMessageKey === exports.ERROR_INVALID_CREDENTIALS ||
                        !isValidInput(passwordInput)
                        ? theme_1.default.color_danger
                        : '' },
                    SignInForm_copyText_1.default.passwordInputLabel,
                    react_1.default.createElement(Asterisk_1.default, { color: palette_1.default.red[60] })), required: true, secondaryText: react_1.default.createElement(Link_1.default, { fontSize: "0.875rem", href: resetPasswordPath, tabIndex: 4 }, SignInForm_copyText_1.default.resetPasswordLinkLabel), tabIndex: 2, type: "password", value: passwordInput.value, variant: errorMessageKey === exports.ERROR_INVALID_CREDENTIALS ||
                    !isValidInput(passwordInput)
                    ? 'danger'
                    : undefined, onChange: handleChange }),
            react_1.default.createElement("input", { type: "hidden", name: "_csrf", value: csrfToken }),
            react_1.default.createElement("input", { type: "hidden", name: "orgSID", value: org.sid })),
        react_1.default.createElement(Layout_1.default.Footer, { paddingVertical: "30px" },
            react_1.default.createElement(Button_1.default, { "data-testid": "submitButton", disabled: !canSubmit, fullWidth: true, primary: true, size: "medium", tabIndex: 3 }, SignInForm_copyText_1.default.submitButtonLabel))));
}
exports.SignInForm = SignInForm;
function isValidInput({ value, isValid }) {
    return (0, isEmpty_1.default)(value) || isValid;
}
function renderErrorMessage({ errorMessageKey }) {
    if (!errorMessageKey)
        return null;
    return (react_1.default.createElement(Alert_1.default, { marginBottom: theme_1.default.space_stack_md, title: (0, lodash_get_1.default)(SignInForm_copyText_1.default, `${errorMessageKey}_title`), variant: "danger" }, (0, lodash_get_1.default)(SignInForm_copyText_1.default, `${errorMessageKey}_message`)));
}
SignInForm.ERROR_INVALID_CREDENTIALS = exports.ERROR_INVALID_CREDENTIALS;
SignInForm.ERROR_UNEXPECTED = exports.ERROR_UNEXPECTED;
SignInForm.ERROR_USER_DEACTIVATED = exports.ERROR_USER_DEACTIVATED;
exports.default = SignInForm;
